import React from 'react';
import { getGlobal } from 'reactn';
import dateDifferenceUsingMoment from '../../../../Utils/util';


const ShowPatient = (props) => {
    const date_options = { year: 'numeric', month: 'short', day: 'numeric'};
    const age = dateDifferenceUsingMoment(getGlobal().PatientDetails && getGlobal().PatientDetails.DOB, new Date());
    console.log(age);
    return (
        <React.Fragment>
            <ul className="showPatientFinal">
                {getGlobal().PatientDetails && getGlobal().PatientDetails.fullName && <><li style={{fontSize: '18px', fontWeight: 'bold'}}>Name: {getGlobal().PatientDetails && getGlobal().PatientDetails.fullName}</li><span>|</span></>}
                {getGlobal().PatientDetails && getGlobal().PatientDetails.DOB && <><li>Age: {age}</li><span>|</span></>}
                {getGlobal().PatientDetails && getGlobal().PatientDetails.gender && <><li>Gender: {getGlobal().PatientDetails && getGlobal().PatientDetails.gender}</li><span>|</span></>}
                {getGlobal().next_visit_date && <><li style={{fontWeight: 'bold'}}>Next Visit (دوبارہ معائنہ): {new Date(getGlobal().next_visit_date).toLocaleDateString('en-US', date_options)}</li><span>|</span></>}
                <li>Date: {new Date(props.appDate ? props.appDate : new Date()).toLocaleDateString('en-US', date_options)}</li>                
            </ul>
        </React.Fragment>
    );
}

export default ShowPatient;
